/* eslint-disable react/no-unescaped-entities */
import { ReactNode } from 'react'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { InfiniteScrollCarousel } from '@/molecules/InfiniteScrollCarousel/InfiniteScrollCarousel'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { HomesteadTitleLG, HomesteadTitleSM, HomesteadTitleXS } from './Typography'

const partnerLogos = [
  {
    src: '/v1727730787/Homestead/partners/boxhouse-logo-gray-2x.png',
    alt: 'boxhouse-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/black-beard-logo-gray-2x.png',
    alt: 'black-beard-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/bakcou-logo-gray-2x.png',
    alt: 'bakcou-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/black-rifle-coffee-company-logo-gray-2x.png',
    alt: 'black-rifle-coffee-company-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/gatorz-logo-gray-2x.png',
    alt: 'gatorz-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/goldbacks-logo-gray-2x.png',
    alt: 'goldbacks-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/fix-it-sticks-logo-gray-2x.png',
    alt: 'fix-it-sticks-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/grip6-logo-gray-2x.png',
    alt: 'grip6-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/knafs-logo-gray-2x.png',
    alt: 'knafs-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/lion-energy-logo-gray2.png',
    alt: 'lion-energy-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/kaito-logo-gray-2x.png',
    alt: 'kaito-logo',
  },
  {
    src: '/v1727730787/Homestead/partners/mira-safety-logo-gray-2x.png',
    alt: 'mira-safety-logo',
  },
  {
    src: '/v1727730788/Homestead/partners/my-medic-logo-gray-2x.png',
    alt: 'my-medic-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/nutrimill-logo-gray-2x.png',
    alt: 'nutrimill-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/oberwerk-logo-gray-2x.png',
    alt: 'oberwerk-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/nutristore-logo-gray-2x.png',
    alt: 'nutristore-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/olli-logo-gray-2x.png',
    alt: 'olli-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/planta-logo-gray-2x.png',
    alt: 'planta-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/protek-logo-gray-2x.png',
    alt: 'protek-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/rockwell-watch-logo-gray-2x.png',
    alt: 'rockwell-watch-logo',
  },
  {
    src: '/v1727730790/Homestead/partners/rockwell-water-logos-gray-2x.png',
    alt: 'rockwell-water-logo',
  },
  {
    src: '/v1727730791/Homestead/partners/sparks-motors-logo-gray-2x.png',
    alt: 'sparks-motors-logo',
  },
  {
    src: '/v1727730793/Homestead/partners/thirsty-earth-logo-gray-2x.png',
    alt: 'thirsty-earth-logo',
  },
  {
    src: '/v1727730793/Homestead/partners/uncharted-supply-logo-gray2.png',
    alt: 'uncharted-supply-logo',
  },
  {
    src: '/v1727730793/Homestead/partners/x-tac-logo-gray-2x.png',
    alt: 'x-tac-logo',
  },
]

export const GiveawaySectionHeader = ({ scrollToProducts }: { scrollToProducts: () => void }) => {
  const { t } = useTranslate('tickets')

  return (
    <>
      <div className="mx-auto max-w-[1080px] items-center justify-start gap-6 bg-white py-[72px] md:px-0">
        <FlexColumn className="mb-12 gap-4">
          <HomesteadTitleLG>{t('howItWorks', 'How it Works')}</HomesteadTitleLG>
          <StepValue step="01">
            <Translate t={t} i18nKey="preOrderTicketsStep1">
              <b>Pre-Order Tickets:</b> Choose a ticket pack from our exclusive pre-order options.
            </Translate>
          </StepValue>
          <StepValue step="02">
            <Translate t={t} i18nKey="preOrderTicketsStep2V2">
              <b>Get Your Promo Codes:</b> Receive promo codes equal to your ticket quantity, redeemable when showtimes
              are available.
            </Translate>
          </StepValue>
          <StepValue step="03">
            <Translate t={t} i18nKey="preOrderTicketsStep3">
              <b>Multiply Your Chances:</b> The earlier you pre-order, the higher your multiplier for the $300k
              Homestead Giveaway.
            </Translate>
          </StepValue>
          <Button
            variant="gray-400"
            className="mt-6 hidden rounded-xl !border-2 !border-homestead-blue px-[24px] pb-[15px] pt-[14px] !font-['bio-sans'] uppercase !text-homestead-blue md:block md:w-fit"
            outline
            onClick={scrollToProducts}
          >
            Pre-Order Tickets
          </Button>
        </FlexColumn>
      </div>
      <div className="my-8">
        <HomesteadTitleXS className="text-center leading-7 md:mb-4" color="homestead-blue">
          <Translate t={t} i18nKey="premiumPartners">
            INCLUDING PRODUCTS FROM OUR PREMIUM PARTNERS
          </Translate>
        </HomesteadTitleXS>
        <InfiniteScrollCarousel images={partnerLogos} />
      </div>
    </>
  )
}

const StepValue = ({ step, children }: { step: string; children: ReactNode }) => (
  <div className="mb-4 flex items-start justify-start gap-2">
    <div className="flex rounded bg-homestead-yellow px-2 pb-0.5 font-['bio-sans'] text-xl font-bold leading-[150%] tracking-wide text-homestead-primary-blue">
      {step}
    </div>
    <HomesteadTitleSM>{children}</HomesteadTitleSM>
  </div>
)
